const state = {
  // Object contains Arrays of Events, ProductCategories, Products
  favourites: {},
  // All product categories visible to the user
  productCategories: [],
  productCategoriesWithProducts: [],

  loadingPromotions: false,
  promotions: [],
  blogs: [],
};

const getters = {
  favourites(state) {
    return state.favourites;
  },
  productCategories(state) {
    return state.productCategories;
  },
  productCategoriesWithProducts(state) {
    return state.productCategoriesWithProducts;
  },
  loadingPromotions(state) {
    return state.loadingPromotions;
  },
  promotions(state) {
    return state.promotions;
  },
  blogs(state) {
    return state.blogs;
  },
};

const mutations = {
  setFavourites(state, favourites) {
    state.favourites = favourites;
  },
  setProductCategories(state, productCategories) {
    state.productCategories = productCategories;
  },
  setProductCategoriesWithProducts(state, productCategoriesWithProducts) {
    state.productCategoriesWithProducts = productCategoriesWithProducts;
  },
  setLoadingPromotions(state, loadingPromotions) {
    state.loadingPromotions = loadingPromotions;
  },
  setPromotions(state, promotions) {
    state.promotions = promotions;
  },
  setBlogs(state, blogs) {
    state.blogs = blogs;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
